import React from 'react';
import SpinnerLogo from "../components/SpinnerLogo"; 

const Loading = ({message}) => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <SpinnerLogo />      
      {/* Loading Text */}
      <p className="mt-10 text-xl font-semibold animate-pulse">
		  {`${message ? message: 'Loading...'}`}
      </p>
    </div>
  );
};

export default Loading;

